<!--
<script lang="ts" context="module">
    import mermaid from "mermaid";
    mermaid.initialize({maxTextSize: 1000000000})
</script>-->
<script lang="ts">
    import {authFetch} from '../Auth'
    import {getRouteById} from "../Nav";
    let svg: string = ''
    let rowCount: number
    let colCount: number
    let table: any[]
    let colMap: Map<string, number>
    let rowMap: Map<string, number>
    async function load(){
        let response = await authFetch('/users/graph', {
            method: 'POST'
        })
        if(response.ok){
            let {counts, links} = await response.json()
            colCount = counts.from_count
            rowCount = counts.to_count
            table = Array(colCount * rowCount)
            colMap = new Map
            rowMap = new Map
            for(let link of links){
                let row = rowMap.get(link.to_id)
                if(row===undefined){
                    row = {index:rowMap.size, count: 0, contact: JSON.parse(link.contact)}
                    rowMap.set(link.to_id, row)
                }
                let col = colMap.get(link.from_id)
                if(col===undefined){
                    col = {index:colMap.size, count: 0, user: JSON.parse(link.user)}
                    colMap.set(link.from_id, col)
                }
                col.count++
                row.count++
                table[colCount * row.index + col.index] = 1;
            }
        }else{
            throw new Error(response.statusText)
        }
    }
    let graphPromise = load()
</script>
<style>
    td{text-align: center;}
    .users th {
        max-width: 1em; white-space: nowrap;
        height: 200px;
        transform-origin: bottom left;
        transform: rotate(-45deg) translate(0em, 1em);
        font-weight: 100;
    }
    .users th:last-child {
        max-width: 100px;
    }
</style>
{#await graphPromise}
    {'Завантаження...'}
{:then _}
    <table class="table table-bordered">
        <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
            <tr class="users">
                <th class="text-end" colspan="2">Цілі:</th>
                {#each [...colMap.values()] as col}
                    <th>{col.user.name ?? col.user.username}</th>
                {/each}
            </tr>
            <tr>
                <th colspan="2">Контакти:</th>
                {#each [...colMap.values()] as col}
                    <th>{col.count}</th>
                {/each}
            </tr>
        </thead>
        <tbody>
            {#each [...rowMap.values()] as row}
                <tr>
                    <th>{row.contact.first_name} {row.contact.last_name} {row.contact.username}</th>
                    <th>{row.count}</th>
                    {#each [...colMap.values()] as col}
                        <td class:bg-primary={table[colCount*row.index+col.index]}></td>
                    {/each}
                </tr>
            {/each}
        </tbody>
    </table>
{/await}
